export default __webpack_public_path__ + "static/media/Conzi-100-ml-eng.d0231275.jpg";